export default "__VITE_ASSET__DL29c4bD__"